import * as React from "react";
import { Table } from "antdv5";
import { IDeviceConnection } from "../../../api_types";
import { ConnectText } from "../../../styles/DeviceConnet";

type MonkeyPatchedIDC = IDeviceConnection & { rank?: number };

interface IProps {
  loading: boolean;
  linkDevice: IDeviceConnection[];
  linkTime: (record: string) => boolean | undefined;
  nowRecord: string | null;
}

const DeviceConnectTable = ({
  loading,
  linkDevice,
  linkTime,
  nowRecord,
}: IProps) => {
  const columns = [
    {
      title: "序号",
      dataIndex: "rank",
      width: 100,
      sorter: (a: MonkeyPatchedIDC, b: MonkeyPatchedIDC) =>
        (a.rank || 0) - (b.rank || 0),
    },
    {
      title: "踏板别名",
      dataIndex: "DeviceName",
      width: 150,
      sorter: (a: MonkeyPatchedIDC, b: MonkeyPatchedIDC) =>
        a.DeviceName.localeCompare(b.DeviceName, "en"),
    },
    {
      title: "连线状态",
      dataIndex: "ClientStatus",
      width: 140,
      render: (text: string, record: MonkeyPatchedIDC) => (
        <ConnectText
          link={parseInt(record.ClientStatus)}
          decoration={
            (parseInt(record.ClientStatus) === 1 &&
              linkTime(record.RecentlyWhenReceivedAnyData)) ||
            false
          }
          onClick={() => console.log(text, record)}
        >
          <div className="expired">
            {parseInt(text) === 1 ? "连线" : "离线"}
          </div>
          <div style={{ zIndex: 1 }}>
            {parseInt(record.ClientStatus) === 1 &&
            linkTime(record.RecentlyWhenReceivedAnyData)
              ? "(逾期)"
              : null}
          </div>
        </ConnectText>
      ),
      sorter: (a: MonkeyPatchedIDC, b: MonkeyPatchedIDC) =>
        parseInt(a.ClientStatus) - parseInt(b.ClientStatus),
    },
    {
      title: "踏板ID",
      dataIndex: "DeviceUUID",
      width: 150,
      sorter: (a: MonkeyPatchedIDC, b: MonkeyPatchedIDC) =>
        a.DeviceUUID.localeCompare(b.DeviceUUID, "en"),
    },
    {
      title: "连线IP",
      dataIndex: "ClientIP",
      width: 150,
      sorter: (a: MonkeyPatchedIDC, b: MonkeyPatchedIDC) =>
        a.ClientIP.localeCompare(b.ClientIP, "en"),
    },

    {
      title: "记录编号",
      dataIndex: "ClientActionID",
      width: 200,
      sorter: (a: MonkeyPatchedIDC, b: MonkeyPatchedIDC) =>
        a.ClientActionID.localeCompare(b.ClientActionID, "en"),
      render: (text: string, record: MonkeyPatchedIDC) => {
        const style =
          record.ClientActionID === nowRecord ? {} : { color: "red" };
        return <td style={style}>{text}</td>;
      },
    },
    {
      title: "踏板时间",
      dataIndex: "ClientClockTime",
      width: 150,
      render: (text: string) => <div>{text.replace(/T/g, " ")}</div>,
      sorter: (a: MonkeyPatchedIDC, b: MonkeyPatchedIDC) =>
        Date.parse(a.ClientClockTime) - Date.parse(b.ClientClockTime),
    },
    {
      title: "最早回应时间",
      dataIndex: "FirstTimeWhenReceivedAnyData",
      width: 150,
      render: (text: string) => (
        <div className="">{text.replace(/T/g, " ")}</div>
      ),
      sorter: (a: MonkeyPatchedIDC, b: MonkeyPatchedIDC) =>
        Date.parse(a.FirstTimeWhenReceivedAnyData) -
        Date.parse(b.FirstTimeWhenReceivedAnyData),
    },
    {
      title: "最后回应时间",
      dataIndex: "RecentlyWhenReceivedAnyData",
      width: 150,
      render: (text: string) => (
        <div className="">{text.replace(/T/g, " ")}</div>
      ),
      sorter: (a: MonkeyPatchedIDC, b: MonkeyPatchedIDC) =>
        Date.parse(a.RecentlyWhenReceivedAnyData) -
        Date.parse(b.RecentlyWhenReceivedAnyData),
    },
  ];

  return (
    <Table
      className="bordered-table-no-white-border"
      columns={columns}
      dataSource={linkDevice}
      pagination={false}
      scroll={{ x: 1250 }}
      rowKey="DeviceUUID"
      size={"small"}
      loading={loading}
      sticky
      style={{ paddingBottom: "3rem" }}
      bordered
    />
  );
};

export default DeviceConnectTable;
